<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane
        :key="treeDirectoryScope"
        :directory-scope="treeDirectoryScope"
        :pane-title="treePaneTitle"
        @tree-node-click="treeNodeClick"
      ></DepartmentPane>
    </section>

    <section class="dp-right">
      <div class="all_page_border">

        <div style="padding-left: 5px">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="学生" name="0">
              <!--工具条-->
              <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList">
                <el-form-item v-if="isBlogAdmin" slot="buttonSlot">
                  <el-button type="success" icon="el-icon-money" @click="openBatchRecharge">批量充值</el-button>
                </el-form-item>
              </toolbar>
            </el-tab-pane>
            <el-tab-pane label="教师" name="1">
              <!--工具条-->
              <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList">
                <el-form-item v-if="isBlogAdmin" slot="buttonSlot">
                  <el-button type="success" icon="el-icon-money" @click="openBatchRecharge">批量充值</el-button>
                </el-form-item>
              </toolbar>
            </el-tab-pane>
          </el-tabs>
        </div>

        <el-alert
          class="refund-hint"
          type="info"
          :closable="false"
          show-icon
          title="余额退回说明"
          description="默认按最近两次可退充值订单办理退款。若最近两次可退金额不足以覆盖账户余额，请联系管理员在【系统运维 → 余额退回前置判断】办理扩笔退款。"
        />

        <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar> -->
        <!--列表-->
        <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
        <div class="tbl-scroll-host">
        <el-table height="100%" :data="users" v-loading="listLoading" @selection-change="handleSelectionChange" @row-click="rowClick" ref="table"
          style="width: 100%" class="custom-tbl" v-if="users">
          <el-table-column type="selection" width="50"></el-table-column>
          <!-- <el-table-column type="index" width="80"></el-table-column> -->
          <el-table-column prop="UserName" label="姓名" width></el-table-column>
          <el-table-column prop="CardNo" label="卡号" width></el-table-column>
          <el-table-column prop="CardStatus" label="用卡状态" width>
            <template slot-scope="scope">
              <template v-if="scope.row.CardNo">
                <el-tag v-if="scope.row.CardStatus === 1" type="danger" size="small">挂失</el-tag>
                <el-tag v-else type="success" size="small">正常</el-tag>
              </template>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="DeptName" label="部门" width></el-table-column>
          <el-table-column prop="Balance" label="账户余额" width></el-table-column>

          <el-table-column fixed="right" label="操作" width="280">
            <template slot-scope="scope">
              <div class="ubl-row-actions">
                <el-button @click="accountChange(scope.row)" type="primary" size="mini" plain icon="el-icon-document">变动明细</el-button>
                <el-button @click="refundChange(scope.row)" type="warning" size="mini" plain icon="el-icon-refresh-left">退回记录</el-button>
                <el-button @click="handleViewLossLog(scope.row)" type="info" size="mini" plain icon="el-icon-time">操作记录</el-button>
                <el-button v-if="scope.row.CardNo && scope.row.CardStatus !== 1" @click="handleLossCard(scope.row)"
                  type="danger" size="mini" plain icon="el-icon-warning-outline">挂失</el-button>
                <el-button v-if="scope.row.CardNo && scope.row.CardStatus === 1" @click="handleUnlossCard(scope.row)"
                  type="success" size="mini" plain icon="el-icon-check">解挂</el-button>
              </div>
            </template>
          </el-table-column>

        </el-table>
        </div>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="float: right"
          />
        </el-col>
      </div>

      <el-dialog
        title="余额变动明细"
        custom-class="ubl-history-dialog"
        :visible.sync="dialogVisible"
        width="780px"
        :close-on-click-modal="false"
        @close="historyDataHandleClose">
        <div class="ubl-history-search">
          <el-input
            v-model="historyKeyword"
            clearable
            placeholder="如食堂/充值"
            style="width: 180px"
            @keyup.enter.native="handleHistorySearch"
          />
          <el-select v-model="historyType" clearable placeholder="类型" style="width: 110px">
            <el-option label="全部" value="" />
            <el-option label="增加" value="1" />
            <el-option label="减少" value="2" />
          </el-select>
          <el-date-picker
            v-model="historyDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 260px"
          />
          <el-button type="primary" icon="el-icon-search" @click="handleHistorySearch">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="handleHistorySearchReset">重置</el-button>
        </div>
        <div class="ubl-history-table-wrap">
          <el-table :data="historyData" class="custom-tbl" max-height="420" style="width: 100%" v-loading="historyLoading">
            <el-table-column property="BalanceBeforeChange" label="变动前余额" min-width="100"></el-table-column>
            <el-table-column prop="ChangeAmount" label="变动余额" min-width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.Type == '1' || scope.row.Type === 1" style="color:orange;">
                  + {{ scope.row.ChangeAmount }}</div>
                <div v-if="scope.row.Type == '2' || scope.row.Type === 2">
                  - {{ scope.row.ChangeAmount }}</div>
              </template>
            </el-table-column>
            <el-table-column property="BalanceAfterChange" label="变动后余额" min-width="100"></el-table-column>
            <el-table-column property="ChangeReason" label="说明" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column property="CreateTime" label="变动时间" min-width="160"></el-table-column>
          </el-table>
        </div>
        <div class="ubl-history-pager">
          <el-pagination
            v-if="dialogVisible"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="historyDataPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="historyPageSize"
            :total="historyDataTotal"
            @size-change="handleHistoryPageSizeChange"
            @current-change="handleHistoryDataChange"
          />
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

      <el-dialog title="退回记录" :visible.sync="refundDialogVisible" width="50%" center @close="refundDataHandleClose">
        <el-table :data="refundData" class="custom-tbl" style="width: 100%">

          <el-table-column prop="TotalAmount" label="退回余额" width>
          </el-table-column>
          <el-table-column property="Remarks" label="备注" width='350'></el-table-column>
          <el-table-column property="CreateTime" label="操作时间" width></el-table-column>
        </el-table>

        <el-col :span="24" class="toolbar">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            @current-change="handleRefundDataChange"
            :page-size="10"
            :total="refundDataTotal"
            style="float: right"
          ></el-pagination>
        </el-col>

        <div slot="footer" class="dialog-footer">
          <el-button @click="refundDialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>

      <!-- 卡片操作记录弹窗 -->
      <el-dialog title="卡片操作记录" :visible.sync="lossLogVisible" width="65%" :close-on-click-modal="false">
        <el-table :data="lossLogs" highlight-current-row v-loading="lossLogLoading" style="width: 100%;">
          <el-table-column prop="CardNo" label="卡号" width=""></el-table-column>
          <el-table-column prop="ActionType" label="操作类型" width="">
            <template slot-scope="scope">
              <el-tag :type="scope.row.ActionType === 1 ? 'danger' : 'success'" size="small">
                {{ scope.row.ActionType === 1 ? '挂失' : (scope.row.ActionType === 2 ? '解挂' : '未知') }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="SourceChannel" label="操作渠道" width="">
            <template slot-scope="scope">
              <span v-if="scope.row.SourceChannel === 1">手机端</span>
              <span v-else-if="scope.row.SourceChannel === 2">PC后台</span>
              <span v-else>其它</span>
            </template>
          </el-table-column>
          <el-table-column prop="OperatorName" label="操作人" width=""></el-table-column>
          <el-table-column prop="CreatedAt" label="操作时间" width=""></el-table-column>
          <el-table-column prop="Remark" label="备注" min-width="" show-overflow-tooltip></el-table-column>
        </el-table>

        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleLossLogCurrentChange"
            :page-size="10" :total="lossLogTotal" style="float:right;">
          </el-pagination>
        </el-col>

        <div slot="footer" class="dialog-footer">
          <el-button @click.native="lossLogVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <el-dialog title="手动充值/扣除/冲正" :visible.sync="rechargeDialogVisible" width="560px" :close-on-click-modal="false" custom-class="beauty-recharge-dialog">
        <el-form label-width="84px" class="recharge-form">
          <el-form-item label="操作类型">
            <el-radio-group v-model="rechargeType" size="small" class="recharge-btn-group">
              <el-radio-button label="1">手动充值</el-radio-button>
              <el-radio-button label="2">手动扣除</el-radio-button>
              <el-radio-button label="3">账户冲正</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="金额" v-if="rechargeType !== '3'">
            <el-input v-model="rechargeAmount" placeholder="请输入金额" type="number" min="0.01" class="recharge-amount-input">
              <template slot="prepend">¥</template>
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="选择记录" v-if="rechargeType === '3'" class="recharge-reverse-item">
            <div class="recharge-reverse-panel">
              <el-select v-model="selectedReverseId" placeholder="请选择要冲正的充值记录" class="recharge-reverse-select">
                <el-option v-for="item in manualRechargeList" :key="item.Id"
                  :label="`${item.ChangeAmount}元 - ${item.CreateTime}`" :value="item.Id" />
              </el-select>
              <div class="recharge-reverse-pager">
                <el-pagination
                  layout="total, prev, pager, next"
                  :page-size="manualRechargeListPageSize"
                  :total="manualRechargeListTotal"
                  :current-page="manualRechargeListPage"
                  @current-change="getManualRechargeList"
                  small
                />
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="rechargeDialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" :loading="rechargeLoading" @click="confirmRecharge" size="small">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 批量充值：仅 admin / blogadmin。创建于 2026-08-21 -->
      <el-dialog title="批量充值" :visible.sync="batchRechargeVisible" width="560px" :close-on-click-modal="false" custom-class="beauty-recharge-dialog">
        <el-form label-width="84px" class="recharge-form">
          <el-form-item label="已选人员">
            <div class="batch-recharge-users">
              共 {{ batchRechargeUsers.length }} 人：{{ batchRechargeUserNames }}
            </div>
          </el-form-item>
          <el-form-item label="充值金额">
            <el-input v-model="batchRechargeAmount" placeholder="请输入统一充值金额" type="number" min="0.01" class="recharge-amount-input">
              <template slot="prepend">¥</template>
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="batchRechargeVisible = false" size="small">取 消</el-button>
          <el-button type="primary" :loading="batchRechargeLoading" @click="confirmBatchRecharge" size="small">确 定</el-button>
        </div>
      </el-dialog>

    </section>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getUserBalanceList, getUserAccountChange, getUserRefundRecords, refund, exportUserBalanceList, manualRechargeBalance, batchManualRechargeBalance, getManualRechargeList, lossCard, unlossCard, getLossLogPageList } from '../../api/modules/consumption';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import superAdminMixin from '../../mixins/superAdminMixin'

export default {
  components: { Toolbar, DepartmentPane },
  mixins: [superAdminMixin],
  data() {
    return {
      activeName: "0",
      filters: {
      },
      searchList: [
        {
          label: '姓名',
          key: 'name',
        },
        {
          label: '卡号',
          key: 'cardNo',
        },
      ],
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: "",
      dialogVisible: false,
      currentDate: "",
      historyData: [],
      historyDataTotal: 0,
      historyDataPage: 1,
      historyPageSize: 10,
      historyUserId: 0,
      historyKeyword: '',
      historyType: '',
      historyDateRange: null,
      historyLoading: false,
      multipleSelection: [],

      refundDialogVisible: false,
      refundData: [],
      refundDataTotal: 0,
      refundDataPage: 1,

      // 挂失记录相关
      lossLogVisible: false,
      lossLogLoading: false,
      lossLogs: [],
      lossLogTotal: 0,
      lossLogSearch: {
        page: 1,
        userId: 0
      },

      //手动充值
      rechargeDialogVisible: false,
      rechargeAmount: '',
      rechargeLoading: false,
      rechargeUser: null,
      rechargeType: '1', // 1=手动充值 2=手动扣除 3=冲正
      manualRechargeList: [],
      selectedReverseId: '',
      manualRechargeListPage: 1,
      manualRechargeListTotal: 0,
      manualRechargeListPageSize: 10,

      // 批量充值（仅超级管理员）
      batchRechargeVisible: false,
      batchRechargeLoading: false,
      batchRechargeAmount: '',
      batchRechargeUsers: [],
    };
  },
  computed: {
    /** 学生=家校，教师=内部通讯录。最后更新：2026-09-04 */
    treeDirectoryScope() {
      return String(this.activeName) === "1" ? "internal" : "teaching";
    },
    treePaneTitle() {
      return this.treeDirectoryScope === "internal" ? "内部通讯录" : "家校通讯录";
    },
    /** 批量充值弹窗展示已选姓名。创建于 2026-08-21 */
    batchRechargeUserNames() {
      const names = (this.batchRechargeUsers || []).map(u => u.UserName || u.CardNo || u.UserId)
      if (names.length <= 8) return names.join('、')
      return names.slice(0, 8).join('、') + ` 等 ${names.length} 人`
    }
  },
  methods: {
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    rowClick(row, column, event) {
      if (column && (column.property === undefined && (column.label === '操作' || column.fixed === 'right'))) {
        return;
      }
      this.$refs.table.toggleRowSelection(row);
    },
    handleClick(tab, event) {
      this.page = 1;
      this.DepartmentId = "";
      this.users = [];
      this.total = 0;
      // 切 Tab 后由部门树 :key 重载并自动选中节点触发查询
    },
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
    },
    callFunction(item) {
      this.currentDate = item.search.date || "";
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    /** 切换每页条数。创建于 2026-08-21 */
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let _this = this;
      let para = {
        page: this.page,
        intPageSize: this.pageSize,
        departmentId: this.DepartmentId,
        ...this.filters,
        type: this.activeName
      };
      this.listLoading = true;
      //NProgress.start();
      getUserBalanceList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      });
    },

    accountChange(row) {
      this.historyUserId = row.UserId;
      this.historyKeyword = '';
      this.historyType = '';
      this.historyDateRange = null;
      this.historyDataPage = 1;
      this.historyPageSize = 10;
      this.historyData = [];
      this.historyDataTotal = 0;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.handleHistoryDataQuery();
      });
    },

    handleHistoryDataChange(val) {
      this.historyDataPage = Number(val) || 1;
      this.handleHistoryDataQuery();
    },
    /** 余额变动明细切换每页条数。创建于 2026-09-05 */
    handleHistoryPageSizeChange(size) {
      const next = Number(size) || 10;
      if (next === this.historyPageSize) return;
      this.historyPageSize = next;
      this.historyDataPage = 1;
      this.handleHistoryDataQuery();
    },
    /** 余额变动明细条件查询。创建于 2026-09-05 */
    handleHistorySearch() {
      this.historyDataPage = 1;
      this.handleHistoryDataQuery();
    },
    /** 重置余额变动明细筛选。创建于 2026-09-05 */
    handleHistorySearchReset() {
      this.historyKeyword = '';
      this.historyType = '';
      this.historyDateRange = null;
      this.historyDataPage = 1;
      this.handleHistoryDataQuery();
    },
    handleHistoryDataQuery() {
      if (!this.historyUserId) return;
      const range = this.historyDateRange || [];
      const pageSize = Number(this.historyPageSize) || 10;
      this.historyPageSize = pageSize;
      let para = {
        page: this.historyDataPage,
        intPageSize: pageSize,
        userId: this.historyUserId,
        keyword: this.historyKeyword || '',
        type: this.historyType || '',
        date: range[0] || '',
        endDate: range[1] || ''
      };
      this.historyLoading = true;
      getUserAccountChange(para).then((res) => {
        this.historyDataTotal = (res.data.response && res.data.response.dataCount) || 0;
        this.historyData = (res.data.response && res.data.response.data) || [];
        if (!this.dialogVisible) this.dialogVisible = true;
      }).finally(() => {
        this.historyLoading = false;
      });
    },

    historyDataHandleClose() {
      this.historyData = [];
      this.historyDataTotal = 0;
      this.historyDataPage = 1;
      this.historyPageSize = 10;
      this.historyKeyword = '';
      this.historyType = '';
      this.historyDateRange = null;
      this.historyLoading = false;
    },

    refundDataHandleClose() {
      this.refundData = [];
      this.refundDataTotal = 0;
      this.refundDataPage = 1;
    },

    refundChange(row) {
      this.historyUserId = row.UserId;
      this.handleRefundDataQuery();
    },
    handleLossCard(row) {
      this.$confirm(`确认要将人员 [${row.UserName}] 的卡片挂失吗?`, "提示", {
        type: "warning",
      }).then(() => {
        this.listLoading = true;
        lossCard({ CardNo: row.CardNo, UserId: row.UserId, DepartmentId: row.DepartmentId, Role: row.Role }).then((res) => {
          this.listLoading = false;
          if (res.data.success) {
            this.$message.success("挂失成功");
            this.handleQuery();
          } else {
            this.$message.error(res.data.msg || "挂失失败");
          }
        }).catch(() => {
          this.listLoading = false;
        });
      }).catch(() => { });
    },
    handleUnlossCard(row) {
      this.$confirm(`确认要将人员 [${row.UserName}] 的卡片解绑/解挂吗?`, "提示", {
        type: "warning",
      }).then(() => {
        this.listLoading = true;
        unlossCard({ CardNo: row.CardNo, UserId: row.UserId, DepartmentId: row.DepartmentId, Role: row.Role }).then((res) => {
          this.listLoading = false;
          if (res.data.success) {
            this.$message.success("解绑/解挂成功");
            this.handleQuery();
          } else {
            this.$message.error(res.data.msg || "解绑/解挂失败");
          }
        }).catch(() => {
          this.listLoading = false;
        });
      }).catch(() => { });
    },
    // 处理查看挂失记录
    handleViewLossLog(row) {
      if (!row || !row.UserId) return;
      this.lossLogSearch.userId = row.UserId;
      this.lossLogSearch.page = 1;
      this.lossLogVisible = true;
      this.getLossLogs();
    },
    // 调用后端接口获取列表
    getLossLogs() {
      this.lossLogLoading = true;
      let para = {
        userId: this.lossLogSearch.userId,
        page: this.lossLogSearch.page,
        intPageSize: 20
      };
      getLossLogPageList(para).then(res => {
        this.lossLogLoading = false;
        if (res.data.success) {
          this.lossLogs = res.data.response.data;
          this.lossLogTotal = res.data.response.dataCount;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(() => {
        this.lossLogLoading = false;
      });
    },
    // 弹层列表翻页
    handleLossLogCurrentChange(val) {
      this.lossLogSearch.page = val;
      this.getLossLogs();
    },

    handleRefundDataChange(val) {
      this.refundDataPage = val;
      this.handleRefundDataQuery();
    },

    handleRefundDataQuery() {
      let para = {
        page: this.refundDataPage,
        userId: this.historyUserId
      };
      getUserRefundRecords(para).then((res) => {
        this.refundDataTotal = res.data.response.dataCount;
        this.refundData = res.data.response.data;
        this.$nextTick(() => { this.refundDialogVisible = true; })
      });
    },
    //余额退回
    handleDel() {
      var rows = this.multipleSelection

      if (rows.length == 0) {
        this.$message({
          message: '请选择要退回的人员！',
          type: 'error',
        })
        return
      }

      if (rows.length > 5) {
        this.$message({
          message: '一次最多选择5条数据',
          type: 'error',
        })
        return
      }

      let arr = [];
      rows.forEach(e => {
        arr.push(e.UserId)
      })

      let para = {
        UserIds: arr,
        Type: this.activeName
      };

      this.$confirm(
        "确认退回所选记录吗？仅支持最近两次可退充值订单；若可退金额不足，请联系管理员在【系统运维-余额退回前置判断】办理。",
        "提示",
        { type: "warning" }
      )
        .then(() => {
          this.listLoading = true;

          refund(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: "操作成功，异步处理中，请勿重复操作。",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },

    async exportExcel() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          ...this.filters,
          type: this.activeName
        };

        var fileName = this.activeName == 0 ? "学生账户余额报表" : "教师账户余额报表";
        const response = await exportUserBalanceList(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }
        // 处理导出数据        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },

    //获取充值记录的方法
    getManualRechargeList(page = 1) {
      this.manualRechargeListPage = page;
      getManualRechargeList({
        UserId: this.rechargeUser.UserId,
        page: this.manualRechargeListPage,
        pageSize: this.manualRechargeListPageSize
      }).then(res => {
        this.manualRechargeList = res.data.response.data || [];
        this.manualRechargeListTotal = res.data.response.dataCount || 0;
      });
    },

    //手动充值
    manualRecharge() {
      var rows = this.multipleSelection
      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择一行数据进行编辑！',
          type: 'error',
        })
        return
      }
      this.rechargeUser = rows[0];
      this.rechargeAmount = '';
      this.rechargeType = '1';
      this.selectedReverseId = '';
      this.rechargeDialogVisible = true;
      // 获取手动充值记录用于冲正
      this.manualRechargeListPage = 1;
      this.getManualRechargeList(1);
    },

    /** 打开批量充值弹窗（仅超级管理员）。创建于 2026-08-21 */
    openBatchRecharge() {
      if (!this.isBlogAdmin) return
      const rows = this.multipleSelection || []
      if (rows.length === 0) {
        this.$message({ message: '请先勾选要充值的人员！', type: 'error' })
        return
      }
      if (rows.length > 50) {
        this.$message({ message: '一次最多选择 50 人进行批量充值', type: 'error' })
        return
      }
      this.batchRechargeUsers = rows.slice()
      this.batchRechargeAmount = ''
      this.batchRechargeVisible = true
    },

    /** 确认批量充值：一次请求后端批量接口。创建于 2026-08-21 */
    async confirmBatchRecharge() {
      if (!this.isBlogAdmin) return
      if (!this.batchRechargeAmount || isNaN(this.batchRechargeAmount) || Number(this.batchRechargeAmount) <= 0) {
        this.$message({ message: '请输入有效的金额！', type: 'error' })
        return
      }
      const amount = Number(this.batchRechargeAmount)
      const users = this.batchRechargeUsers || []
      if (!users.length) {
        this.$message({ message: '没有可充值的人员！', type: 'error' })
        return
      }
      try {
        await this.$confirm(`确定给 ${users.length} 人各充值 ¥${amount} 吗？`, '批量充值确认', { type: 'warning' })
      } catch (e) {
        return
      }
      this.batchRechargeLoading = true
      try {
        const res = await batchManualRechargeBalance({
          UserIds: users.map(u => u.UserId),
          Amount: amount,
          Type: Number(this.activeName)
        })
        if (res.data && res.data.success) {
          const data = res.data.response || {}
          const failNames = data.FailNames || data.failNames || []
          const successCount = data.SuccessCount != null ? data.SuccessCount : (data.successCount || 0)
          if (failNames.length === 0) {
            this.$message({ message: res.data.msg || `批量充值成功，共 ${successCount} 人`, type: 'success' })
          } else {
            this.$message({
              message: `成功 ${successCount} 人，跳过 ${failNames.length} 人：${failNames.slice(0, 5).join('、')}${failNames.length > 5 ? '…' : ''}`,
              type: 'warning',
              duration: 6000,
              showClose: true
            })
          }
          this.batchRechargeVisible = false
          this.handleQuery()
        } else {
          this.$message({ message: (res.data && res.data.msg) || '批量充值失败！', type: 'error' })
        }
      } catch (e) {
        this.$message({ message: '批量充值失败！', type: 'error' })
      } finally {
        this.batchRechargeLoading = false
      }
    },

    async confirmRecharge() {
      if (this.rechargeType !== '3' && (!this.rechargeAmount || isNaN(this.rechargeAmount) || Number(this.rechargeAmount) <= 0)) {
        this.$message({
          message: '请输入有效的金额！',
          type: 'error',
        });
        return;
      }
      if (this.rechargeType === '3' && !this.selectedReverseId) {
        this.$message({
          message: '请选择要冲正的充值记录！',
          type: 'error',
        });
        return;
      }
      let opText = this.rechargeType === '1' ? '充值' : this.rechargeType === '2' ? '扣除' : '冲正';
      this.$confirm(`确定要${opText}吗？`, '提示', {
        type: 'warning'
      }).then(async () => {
        this.rechargeLoading = true;
        try {
          let para = {
            UserId: this.rechargeUser.UserId,
            Type: this.activeName,
            OpType: this.rechargeType // 1=充值 2=扣除 3=冲正
          };
          if (this.rechargeType === '3') {
            para.AccountChangeId = this.selectedReverseId;
          } else {
            para.Amount = Number(this.rechargeAmount);
          }
          const res = await manualRechargeBalance(para);
          if (res.data && res.data.success) {
            this.$message({
              message: opText + '成功！',
              type: 'success',
            });
            this.rechargeDialogVisible = false;
            this.handleQuery();
          } else {
            this.$message({
              message: res.data && res.data.msg ? res.data.msg : opText + '失败！',
              type: 'error',
            });
          }
        } catch (e) {
          this.$message({
            message: opText + '失败！',
            type: 'error',
          });
        }
        this.rechargeLoading = false;
      }).catch(() => { });
    },

  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl {
  cursor: pointer;
}

.ubl-row-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 8px;
  align-items: center;
}

.ubl-row-actions >>> .el-button {
  margin: 0 !important;
}

.ubl-row-actions >>> .el-button.is-plain:hover,
.ubl-row-actions >>> .el-button.is-plain:focus {
  position: relative;
  z-index: 1;
  box-shadow: none;
  transform: none;
}

.batch-recharge-users {
  line-height: 1.55;
  color: #475569;
  word-break: break-all;
}

.refund-hint {
  margin-bottom: 12px;
}
</style>

<style>
/* 余额变动明细：表格固定高度内滚动。创建于 2026-09-05 */
.ubl-history-dialog {
  border-radius: 12px;
}
.ubl-history-dialog .el-dialog__body {
  padding: 12px 20px 8px;
  overflow: hidden;
}
.ubl-history-search {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.ubl-history-table-wrap {
  width: 100%;
}
.ubl-history-pager {
  display: flex;
  justify-content: flex-end;
  padding: 12px 0 4px;
}
</style>

<style>
/* 手动充值弹窗（append-to-body，不可 scoped）。最后修改：2026-08-29 */
.beauty-recharge-dialog {
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
  overflow: hidden;
}

.beauty-recharge-dialog .el-dialog__header {
  padding: 16px 20px;
  background: #fafbfc;
  border-bottom: 1px solid #e8edf3;
}

.beauty-recharge-dialog .el-dialog__title {
  font-weight: 500;
  color: #0f172a;
  font-size: 16px;
}

.beauty-recharge-dialog .el-dialog__body {
  padding: 24px 24px 12px;
}

.beauty-recharge-dialog .el-dialog__footer {
  padding: 12px 20px 16px;
  background: #fafbfc;
  border-top: 1px solid #e8edf3;
}

.beauty-recharge-dialog .recharge-form .el-form-item {
  margin-bottom: 18px;
}

.beauty-recharge-dialog .recharge-form .el-form-item__label {
  font-weight: 400;
  color: #475569;
  line-height: 32px;
}

.beauty-recharge-dialog .recharge-form .el-form-item__content {
  line-height: 32px;
}

.beauty-recharge-dialog .recharge-btn-group {
  display: flex;
  gap: 8px;
  width: 100%;
}

.beauty-recharge-dialog .recharge-btn-group .el-radio-button {
  flex: 1;
}

.beauty-recharge-dialog .recharge-btn-group .el-radio-button__inner {
  width: 100%;
  border-radius: 8px !important;
  border: 1px solid #e2e8f0 !important;
  margin-left: 0 !important;
  padding: 8px 12px;
  font-weight: 400;
  color: #475569;
  background: #fff;
  box-shadow: none !important;
  transition: color 0.2s ease, border-color 0.2s ease, background-color 0.2s ease;
}

.beauty-recharge-dialog .recharge-btn-group .el-radio-button:first-child .el-radio-button__inner,
.beauty-recharge-dialog .recharge-btn-group .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 8px !important;
}

.beauty-recharge-dialog .recharge-btn-group .el-radio-button__inner:hover {
  color: var(--btn-primary, #2563eb);
  border-color: #93c5fd !important;
  background: #f8fafc;
  z-index: 1;
  position: relative;
}

.beauty-recharge-dialog .recharge-btn-group .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: var(--btn-primary, #2563eb);
  background: #eff6ff;
  border-color: var(--btn-primary, #2563eb) !important;
  box-shadow: none !important;
}

.beauty-recharge-dialog .recharge-amount-input {
  width: 100%;
}

.beauty-recharge-dialog .recharge-amount-input .el-input-group__prepend,
.beauty-recharge-dialog .recharge-amount-input .el-input-group__append {
  background-color: #f8fafc;
  color: #64748b;
  font-weight: 400;
  border-color: #e2e8f0;
}

.beauty-recharge-dialog .recharge-amount-input .el-input__inner {
  font-size: 14px;
  font-weight: 400;
  color: #0f172a;
}

.beauty-recharge-dialog .recharge-reverse-panel {
  width: 100%;
}

.beauty-recharge-dialog .recharge-reverse-select {
  width: 100%;
}

.beauty-recharge-dialog .recharge-reverse-pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f1f5f9;
}

.beauty-recharge-dialog .recharge-reverse-pager .el-pagination {
  padding: 0;
}
</style>
